import "./VenueInformation.scss";

import imgUp from "../../assets/images/icons/img-upload.svg";
import checkmark from "../../assets/images/icons/check-mark.svg";

import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";

function VenueInformation({ specVenue }) {
    const navigate = useNavigate();
    // const [image, setImage] = useState(null);
    const fileInputRef = useRef(null);

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleImageUpload = (event) => {
        const selectedFiles = Array.from(event.target.files);
        console.log("Selected files:", selectedFiles);
        // Handle file upload or any other processing here
    };

    //NEW INPUT ======================================================

    const [updatedName, setUpdatedName] = useState("");
    const [updatedCat, setUpdatedCat] = useState("");
    const [updatedAddress, setUpdatedAddress] = useState("");
    const [updatedHours, setUpdatedHours] = useState("");
    const [updatedUrl, setUpdatedUrl] = useState("");
    const [updatedEmail, setUpdatedEmail] = useState("");
    const [updatedPrice, setUpdatedPrice] = useState("");
    const [updatedAbout, setUpdatedAbout] = useState("");
    const [updatedPhone, setUpdatedPhone] = useState("");
    const [updatedTags, setUpdatedTags] = useState("");
    const [updatedLat, setUpdatedLat] = useState("");
    const [updatedLong, setUpdatedLong] = useState("");
    const [updatedDress, setUpdatedDress] = useState("");
    const [updatedMusic, setUpdatedMusic] = useState("");

    function handleEditVenueSubmit(event) {
        event.preventDefault();

        const updatedVenue = {
            name: updatedName,
            category: updatedCat,
            address: updatedAddress,
            hours: updatedHours,
            url: updatedUrl,
            price: updatedPrice,
            email: updatedEmail,
            phone: updatedPhone,
            lat: updatedLat,
            lng: updatedLong,
            dress: updatedDress,
            music: updatedMusic,
            about: updatedAbout,
        };

        // console.log(updatedVenue)

        const updateVenue = async () => {
            try {
                await axios.put(
                    `https://zona-app-server-584d567d8841.herokuapp.com/venues/${specVenue.id}`,
                    updatedVenue
                );
                navigate("/venues");
            } catch (err) {
                console.log(`error udating this venue. this was the error: ${err}`);
            }
        };
        updateVenue();
    }

    return (
        <article className="venue-info">
            <form onSubmit={handleEditVenueSubmit} className="venue-info__form">
                <div className="venue-info__form--left">
                    <div className="venue-info__form-group">
                        <div className="venue-info__form-group-field">
                            <label htmlFor="venueName" className="venue-info__form-group-field-label">
                                Name
                            </label>
                            <input
                                type="text"
                                id="venueName"
                                name="name"
                                value={updatedName}
                                onChange={(event) => setUpdatedName(event.target.value)}
                                placeholder={specVenue?.name}
                                className="venue-info__form-group-field-input"
                            ></input>
                        </div>

                        <div className="venue-info__form-group-field">
                            <label htmlFor="venueCat" className="venue-info__form-group-field-label">
                                Category
                            </label>
                            <input
                                type="text"
                                id="venueCat"
                                name="category"
                                value={updatedCat}
                                onChange={(event) => setUpdatedCat(event.target.value)}
                                placeholder={specVenue?.category}
                                className="venue-info__form-group-field-input"
                            ></input>
                        </div>
                    </div>

                    <div className="venue-info__form-group">
                        <div className="venue-info__form-group-field">
                            <label htmlFor="venueAddress" className="venue-info__form-group-field-label">
                                Address
                            </label>
                            <input
                                type="text"
                                id="venueAddress"
                                name="address"
                                value={updatedAddress}
                                onChange={(event) => setUpdatedAddress(event.target.value)}
                                placeholder={specVenue.address || "Enter address"}
                                className="venue-info__form-group-field-input"
                            ></input>
                        </div>

                        <div className="venue-info__form-group-field">
                            <label htmlFor="venueHours" className="venue-info__form-group-field-label">
                                Hours of operation
                            </label>
                            <input
                                type="text"
                                id="venueHours"
                                name="hours"
                                value={updatedHours}
                                onChange={(event) => setUpdatedHours(event.target.value)}
                                placeholder={specVenue.hours || "Enter hours"}
                                className="venue-info__form-group-field-input"
                            ></input>
                        </div>
                    </div>

                    <div className="venue-info__form-group">
                        <div className="venue-info__form-group-field">
                            <label htmlFor="venueLong" className="venue-info__form-group-field-label">
                                Longitude
                            </label>
                            <input
                                type="text"
                                id="venueLong"
                                name="lng"
                                value={updatedLong}
                                onChange={(event) => setUpdatedLong(event.target.value)}
                                placeholder={specVenue.lng || "Enter longitude"}
                                className="venue-info__form-group-field-input"
                            />
                        </div>

                        <div className="venue-info__form-group-field">
                            <label htmlFor="venueLat" className="venue-info__form-group-field-label">
                                Latitude
                            </label>
                            <input
                                type="text"
                                id="venueLat"
                                name="lat"
                                value={updatedLat}
                                onChange={(event) => setUpdatedLat(event.target.value)}
                                placeholder={specVenue.lat || "Enter latitude"}
                                className="venue-info__form-group-field-input"
                            />
                        </div>
                    </div>

                    <div className="venue-info__form-group">
                        <div className="venue-info__form-group-field">
                            <label htmlFor="venuePhone" className="venue-info__form-group-field-label">
                                Phone
                            </label>
                            <input
                                type="text"
                                id="venuePhone"
                                name="phone"
                                value={updatedPhone}
                                onChange={(event) => setUpdatedPhone(event.target.value)}
                                placeholder={specVenue.phone || "Enter phone"}
                                className="venue-info__form-group-field-input"
                            ></input>
                        </div>

                        <div className="venue-info__form-group-field">
                            <label htmlFor="venueSite" className="venue-info__form-group-field-label">
                                Website
                            </label>
                            <input
                                type="text"
                                id="venueSite"
                                name="url"
                                value={updatedUrl}
                                onChange={(event) => setUpdatedUrl(event.target.value)}
                                placeholder={specVenue.url || "Enter website"}
                                className="venue-info__form-group-field-input"
                            ></input>
                        </div>
                    </div>

                    <div className="venue-info__form-group">
                        <div className="venue-info__form-group-field">
                            <label htmlFor="venueEmail" className="venue-info__form-group-field-label">
                                E-mail
                            </label>
                            <input
                                type="email"
                                id="venueEmail"
                                name="email"
                                value={updatedEmail}
                                onChange={(event) => setUpdatedEmail(event.target.value)}
                                placeholder={specVenue.email || "Enter e-mail"}
                                className="venue-info__form-group-field-input"
                            ></input>
                        </div>

                        <div className="venue-info__form-group-field">
                            <label htmlFor="venuePrice" className="venue-info__form-group-field-label">
                                Price
                            </label>
                            <input
                                type="text"
                                id="venuePrice"
                                name="price"
                                value={updatedPrice}
                                onChange={(event) => setUpdatedPrice(event.target.value)}
                                placeholder={specVenue.price || "Enter price"}
                                className="venue-info__form-group-field-input"
                            ></input>
                        </div>
                    </div>

                    <div className="venue-info__form-group">
                        <div className="venue-info__form-group-field">
                            <label htmlFor="venueDressCode" className="venue-info__form-group-field-label">
                                Dress-code
                            </label>
                            <input
                                type="text"
                                id="venueDressCode"
                                name="dress"
                                value={updatedDress}
                                onChange={(event) => setUpdatedDress(event.target.value)}
                                placeholder={specVenue.dress || "Enter dress-code"}
                                // placeholder='Enter dress code'
                                className="venue-info__form-group-field-input"
                            ></input>
                        </div>

                        <div className="venue-info__form-group-field">
                            <label htmlFor="venueMusic" className="venue-info__form-group-field-label">
                                Music
                            </label>
                            <input
                                type="text"
                                id="venueMusic"
                                name="music"
                                value={updatedMusic}
                                onChange={(event) => setUpdatedMusic(event.target.value)}
                                placeholder={specVenue.music || "Enter music"}
                                // placeholder='Enter music'
                                className="venue-info__form-group-field-input"
                            ></input>
                        </div>
                    </div>

                    <div className="venue-info__form-group-about">
                        <label htmlFor="venueAbout" className="venue-info__form-group-field-label">
                            About
                        </label>
                        <textarea
                            rows={4}
                            id="venueAbout"
                            name="about"
                            className="venue-info__form-group-about-input"
                            value={updatedAbout}
                            onChange={(event) => setUpdatedAbout(event.target.value)}
                            placeholder={specVenue.about || "Enter description"}
                        />
                    </div>

                    <button type="submit" className="venue-info__form-submit">
                        <p className="venue-info__form-submit-text">Update information</p>

                        <img src={checkmark} alt="check mark"></img>
                    </button>
                </div>
                <div className="venue-info__form-group-images">
                    <div className="venue-info__form-group-images-input">
                        <input
                            type="file"
                            accept="image/*"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={handleImageUpload}
                        />
                        <button className="venue-info__form-group-images-input-button" onClick={handleButtonClick}>
                            <img
                                src={imgUp}
                                className="venue-info__form-group-images-input-button-img"
                                alt="click here to upload a file"
                            ></img>
                        </button>
                    </div>
                </div>
            </form>
        </article>
    );
}

export default VenueInformation;
